import { $ } from "@olmokit/dom";
import Olmoforms from "@olmokit/core/olmoforms/feedback";
import Dependency from "@olmokit/core/olmoforms/dependency";
import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import "@olmokit/core/forms/checkbox";
import "@olmokit/core/forms/textarea/filled";
import { dataLayerForm, salesforceCommunication } from "components/Datalayer";
import "./index.scss";
import axios from 'axios';
import { globalConf } from "@olmokit/core/data";
import { post } from "@olmokit/core/fragments/ajax";

/**
 * Component: FormPrivate
 *
 */
export function FormPrivate() {

  let ip = '';

  const olmoform = Olmoforms(".Contacts:private", {
    before: async (formData) => {
      console.log('step 1');
      console.log(formData);

      const $localcheck = $('#of-1-localcheck');
      if ($localcheck.value !== '') {
        console.log('stopped');
        olmoform.boot(); // Halts submission
        return Promise.reject("Local check failed");
      }

      try {
        console.log('detectip');
        const { data } = await post('detectip', {
          data: { item: '$minimal' }
        });
        console.log('step 2');
        ip = data;

        const token = await grecaptcha.execute('6LfzBrYrAAAAAPZEBP-w_GyN9AcH18mZA2w6i4NO', { action: 'submit' });
        console.log('step 3');

        await axios.post(globalConf.cmsApiUrl + '/recaptcha', {
          token,
          ip,
        });

        console.log('step 4');
        console.log('recaptcha done');
      } catch (error) {
        console.error('step ERROR', error);
        olmoform.boot(); // Prevents submit if reCAPTCHA or detectip fails
        return Promise.reject("Hook before failed");
      }

      console.log('step 5 (end)');

    },
    sent: (response) => {
      const { data, formData } = response;
      dataLayerForm("form sent", formData, "Form Private", $('#of-1-usertype').value, $('#of-1-requesttype').value);
      // Do not send private info to SF
      // salesforceCommunication(formData, "Form Private", $('#of-1-usertype').value, $('#of-1-requesttype').value);
      axios.post(globalConf.cmsApiUrl + '/formscompiler', {
        email: formData['email'],
        ip: ip,
      })
        .then(() => {
          console.log('step 7');
          console.log('formscompiler done');
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  FormsInputMaterial();
  FormsSelectMaterial();
  Dependency(".Contacts:private");

  return {
    destroy() {
      olmoform.destroy();
    },
  };

}
